const accordions = document.querySelectorAll(".custom-ribbon-accordion-toggle");

Array.from(accordions).forEach((accordion) => {
  accordion.addEventListener("click",  () => {
    accordion.classList.toggle("open");
    const panel = accordion.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
})  
